<div class="custom-security-link">
  <a *ngIf="_router.url!='/goal/list'" [routerLink]="['/goal/list']" routerLinkActive="active">Goals List</a>
  <a  *ngIf="_router.url!='/goal/setup'" [routerLink]="['/goal/setup']" routerLinkActive="active">Goals Setup</a>
</div>
<div class="margin-all-area">
  <router-outlet></router-outlet>
</div>
